import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export const useDeleteImpactRatingsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.impactRating.deleteBatch.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impactRating.impactRatings.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impactRating.impactRatingById.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsByImpactId.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsByRatedItemId.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.impactRating.impactRatingsWithAppetites.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.impactRating.impactRatingCount.queryKey(),
          }),
          // Assessment views may show rating data
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.assessment.register.queryKey(),
          }),
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.assessment.resultsRegister.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    deleteImpactRatings: async (variables: {
      Ids: string[];
    }): Promise<void> => {
      await mutation.mutateAsync({ Ids: variables.Ids });
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
